import { connect } from 'react-redux';
import { reduxForm, change, formValueSelector } from 'redux-form';
import { createTaxRate, fetchTaxRates, editMultiTaxes, deleteTax } from '../../actions/sales_actions';

import TaxManagement from '../../components/Settings/taxManagement';

const validate = values => {
    const errors = {}
    if (!values.Name) {
        errors.Name = 'Require'
    }
    if (!values.Rate) {
        errors.Rate = 'Require'
    }
    return errors
}

let taxManagement = reduxForm({
    form: 'taxManagement',
    validate
})(TaxManagement)

const selector = formValueSelector('taxManagement')

function mapStateToProps(state) {
    const Name = selector(state, 'Name');
    const Rate = selector(state, 'Rate');
    const State = selector(state, 'State');

    return {
      Name,
      Rate,
      State,

      taxRates: state.salesOrders.taxRates,
      taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
      taxRatesError: state.salesOrders.taxRatesError,

      creatingTaxRate: state.salesOrders.creatingTaxRate,
      createTaxRateSuccess: state.salesOrders.createTaxRateSuccess,
      createTaxRateFailure: state.salesOrders.createTaxRateFailure,

      multiTaxesIsEditing: state.salesOrders.multiTaxesIsEditing,
      multiTaxesEdited: state.salesOrders.multiTaxesEdited,
      multiTaxesEditError: state.salesOrders.multiTaxesEditError,

      taxIsDeleting: state.salesOrders.taxIsDeleting,
      taxDeleted: state.salesOrders.taxDeleted,
      taxDeleteError: state.salesOrders.taxDeleteError,

    };
}

export default connect(mapStateToProps, {
  createTaxRate, fetchTaxRates, editMultiTaxes, deleteTax })(taxManagement);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/taxManagement.jsx